class heroSlider extends HTMLElement {
  constructor() {
    super();
    const totalCelebs = this.querySelectorAll('[data-show-slide]');
    const slideCount = this.querySelector('[data-slide-count]');
    const slideCountMob = this.querySelector('[data-slide-count-mob]');
    const totalCelebsArray = Array.from(totalCelebs);
    const totalSlides = totalCelebsArray.length;
    var activeSlideIndex;

    let thumbnailSwiper = new Swiper('[data-thumbnail-slider]', {
      slidesPerView: 6,
      spaceBetween: 20
    }); 
  
    let bannerSwiper = new Swiper('[data-hero-slider]', {
      slidesPerView: 1, 
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
      speed: 1000,
      navigation: {
        nextEl: '.hero__button-mob .hero__button-next',
        prevEl: '.hero__button-mob .hero__button-prev'
      },
      breakpoints: {
        768: {
          navigation: {
            nextEl: '.hero__thumbnail-desk .hero__button-next',
            prevEl: '.hero__thumbnail-desk .hero__button-prev'
          }
        }
      },
      thumbs: {
        swiper: thumbnailSwiper
      },
      on: {
        slideChangeTransitionEnd: function() {
          let slideCurrentIndex = this.realIndex;
          totalCelebsArray.forEach(function(item,index) {
            if (index == slideCurrentIndex) {
              item.classList.add("hero__thumbnail-slide-active");
              activeSlideIndex = item.getAttribute("data-slide-index");
            }
            else {
              item.classList.remove("hero__thumbnail-slide-active");
            }
          });
          slideCount.innerText = `${activeSlideIndex} / ${totalSlides}`;
          slideCountMob.innerText = `${activeSlideIndex} / ${totalSlides}`;
      }}
    });
    
    this.querySelectorAll('[data-show-slide]').forEach(item =>
      item.addEventListener('click', function() {
      var currentSlideIndex = this.getAttribute("data-slide-index");
      bannerSwiper.slideTo(currentSlideIndex, 1000);
    })
    )  
    slideCount.innerText = `1 / ${totalSlides}`
    slideCountMob.innerText = `1 / ${totalSlides}`;
  }
}
customElements.define('hero-slider', heroSlider);